import { ProcurementType } from 'models/procurement.model';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export type ProcurementContextType = {
  procurementToUpdate: ProcurementType;
  setProcurementToUpdate: Dispatch<SetStateAction<ProcurementType>>;
};

export const ProcurementContext = createContext({} as ProcurementContextType);
const useProcurementContext = () => {
  const context = useContext(ProcurementContext);
  return context;
};

export default useProcurementContext;
